import { render, staticRenderFns } from "./dragDialog.vue?vue&type=template&id=65ce74f0&scoped=true"
import script from "./dragDialog.vue?vue&type=script&lang=js"
export * from "./dragDialog.vue?vue&type=script&lang=js"
import style0 from "./dragDialog.vue?vue&type=style&index=0&id=65ce74f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce74f0",
  null
  
)

export default component.exports